export default {"src":"/_next/static/media/verizon.79eecf63.svg","height":16,"width":67,"blurWidth":0,"blurHeight":0};